import { render, staticRenderFns } from "./TotalSummary.vue?vue&type=template&id=58fde789&scoped=true&"
import script from "./TotalSummary.vue?vue&type=script&lang=ts&"
export * from "./TotalSummary.vue?vue&type=script&lang=ts&"
import style0 from "./TotalSummary.vue?vue&type=style&index=0&id=58fde789&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fde789",
  null
  
)

export default component.exports